// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./asset/fonts/General-Sans/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./asset/fonts/General-Sans/GeneralSans-ExtralightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./asset/fonts/General-Sans/GeneralSans-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./asset/fonts/General-Sans/GeneralSans-Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./asset/fonts/General-Sans/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./asset/fonts/General-Sans/GeneralSans-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./asset/fonts/General-Sans/GeneralSans-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./asset/fonts/General-Sans/GeneralSans-SemiboldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/asset/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/asset/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/asset/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto,
    'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
}

body {
  font-family: Arial, Helvetica, sans-serif; /* Fallback font */
  background-color: #F7FAFF; /* Fallback background color */
  overflow: hidden;
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

@font-face {
  font-family: "General-Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___}), url(${___CSS_LOADER_URL_REPLACEMENT_2___}), url(${___CSS_LOADER_URL_REPLACEMENT_3___}), url(${___CSS_LOADER_URL_REPLACEMENT_4___}), url(${___CSS_LOADER_URL_REPLACEMENT_5___}), url(${___CSS_LOADER_URL_REPLACEMENT_6___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_9___}), url(${___CSS_LOADER_URL_REPLACEMENT_10___}), url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-display: swap;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-display: swap;
}
* {
  margin: 0;
  padding: 0;
}

.filled {
  font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 48;
  font-display: swap;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  font-size: 1rem;
  margin: auto;
}

/* .calenderComponentDark .rdrYearPicker select{
  color: #BFBFBF;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 52%;
    border-radius: 2px;
}
.calenderComponentDark .rdrMonthPicker select{
  color: #BFBFBF;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 52%;
    border-radius: 2px;
} */
/* .calenderComponentDark .rdrYearPicker option{
  background-color: #5A5A5A;
  color: #DCDCDC;
}

.calenderComponentDark .rdrMonthPicker option{
  background-color: #5A5A5A;
  color: #DCDCDC;
} */
/* For Light Theme */
.calenderComponent .rdrYearPicker option {
  background-color: #5a5a5a;
  color: #dcdcdc;
}

.calenderComponent .rdrMonthPicker option {
  background-color: #5a5a5a;
  color: #dcdcdc;
}

.rdrDayToday .rdrDayNumber span:after {
  display: none;
}

.calenderComponentDark .rdrDefinedRangesWrapper {
  display: none;
}

/* .calenderComponentDark .rdrDateRangeWrapper{
  background: #3B3B3C;
}

.calenderComponentDark .rdrDayNumber span {
  color: #BFBFBF;
  font-weight: 500;
font-size: 15px;
}

.calenderComponentDark .rdrMonthAndYearPickers{
  font-weight: 500;
font-size: 18px;
color: #BFBFBF;
} */
.calenderComponent .rdrDayNumber span {
  color: #444f5f;
  font-weight: 500;
  font-size: 14px;
}

.calenderComponent .rdrMonthAndYearPickers select {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #444f5f;
}

.calenderComponent .rdrMonthAndYearWrapper .rdrNextPrevButton {
  background: #d9d9d9;
}

.calenderComponent .rdrDefinedRangesWrapper {
  display: none;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background: #349ef5;
  border: 0px none #ffffff;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #005aa3;
}

::-webkit-scrollbar-thumb:active {
  background: #004f8f;
}

::-webkit-scrollbar-track {
  background: #c7c7c7;
  border: 0px none #ffffff;
  border-radius: 50px;
}

::-webkit-scrollbar-track:hover {
  background: #bfbfbf;
}

::-webkit-scrollbar-track:active {
  background: #bfbfbf;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.solid-icon {
  font-variation-settings: "FILL" 1, "wght" 300, "GRAD" 0, "opsz" 48;
}

.outlined-icon {
  font-variation-settings: "FILL" 0, "wght" 300, "GRAD" 0, "opsz" 48;
}

/* theme toggle button css */
.react-switch {
  border: 1px solid #ccc;
}

/* .carousel.carousel-slider .control-arrow {
  color: #fff;
  font-size: 26px;
  margin-top: 50%;
  border-radius: 50%;
  height: 50px;
  width: 50px;
} */
.carousel-div {
  height: 100%;
  width: 100%;
  /* background-image: url('./asset/images/Carousel.svg'); */
}

.carousel-slider {
  width: 100%;
  height: 100%;
}

.carousel .slider-wrapper {
  height: 100%;
}

.carousel .slider-wrapper.axis-horizontal .slider {
  width: 100%;
  height: 100%;
}

.carousel .slide {
  width: 100%;
  height: 100%;
}

.carousel-status {
  display: none;
}

/* .carousel .slide img {
  width:auto;
  height:100%

}
.carousel .img{
  width:auto;
  height:100%
} */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.card-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-text-attendence {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.header-glow {
  animation: glow 2s infinite linear;
  animation-fill-mode: forwards;
}

@keyframes splash {
  0% {
    opacity: 1;
    z-index: 4;
  }
  90% {
    opacity: 1;
    z-index: 4;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
.splash-screen {
  animation: splash 6.1s linear;
  animation-fill-mode: forwards;
}

.blur-Modal {
  position: absolute;
  z-index: 100;
  top: 0px;
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.blur-Modal .blur-Modal-content {
  overflow: hidden;
}

.blur-Modal .blur-Modal-content .inner-body-modal {
  background: rgba(128, 128, 128, 0.3);
  padding: 25px;
  border-radius: 8px;
  position: relative;
  z-index: 4;
  margin-top: 60px;
}

[role=grid] {
  width: 94vw !important;
}

/* .react-draggable {
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  transform: none;
} */
/* @media screen and (max-width: 768px) {
  .react-draggable {
    transform: none !important;
  }
} */
/* [aria-label='Screen share control bar'] .zmwebsdk-MuiBox-root {
  flex-wrap: wrap !important;
} */
/* .zmwebsdk-MuiPaper-root {
  width: 100vw !important;
  min-width: 100vw !important;
  max-width: 100vw !important;
}
.react-draggable .zmwebsdk-MuiPaper-root .zmwebsdk-MuiBox-root {
  height: 100vh;
  width: 100vw;
}
#meetingSDKElement .zmwebsdk-makeStyles-videoCustomize-1 {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
#suspension-view-tabpanel-active > div:first-child {
  height: 88vh;
}
[class^='zmwebsdk-makeStyles-draggableDivider'] {
  display: none !important;
}
[class*='zmwebsdk-makeStyles-inSharing'] {
  height: 90vh !important;
}
[class*='zmwebsdk-makeStyles-inSharing'] .zmwebsdk-MuiBox-root {
  height: 24px !important;
  width: 100% !important;
  position: fixed;
  top: 36px !important;
  transform: none;
  max-width: none !important;
}

#suspension-view-tabpanel-active {
  height: 83vh;
}
.zmwebsdk-makeStyles-videoCustomize-1 .zmwebsdk-MuiPaper-root {
  box-shadow: none;
} */
#meetingSDKElement {
  height: 100vh;
  width: 100vw;
  background-color: #242424;
  display: none;
}

#menu-list-undefined li:first-child {
  display: none;
}

#participants-ul {
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.material-symbols-outlined {
  font-family: "Material Symbols Outlined" !important;
  font-display: swap;
}

.material-symbols-rounded {
  font-display: swap;
}

button:not(:disabled) {
  cursor: pointer;
}

button {
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

[type=button],
[type=reset],
[type=submit],
button {
  -webkit-appearance: button;
}

button,
select {
  text-transform: none;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button {
  border-radius: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.position-relative {
  position: relative;
}

@media screen and (max-width: 768px) {
  .common-window {
    width: 100vw !important;
    height: 90vh !important;
  }
  .sharee-sharing-indicator {
    max-width: 100vw !important;
  }
  .sharee-sharing-indicator__tip {
    padding: 0 7px !important;
    max-width: calc(100vw - 125px);
  }
  h1 {
    font-size: calc(1.375rem + 1.5vw);
  }
  h2 {
    font-size: calc(1.325rem + 0.9vw);
  }
  h3 {
    font-size: calc(1.3rem + 0.6vw);
  }
  h4 {
    font-size: calc(1.275rem + 0.3vw);
  }
  h5 {
    font-size: 1.25rem;
  }
  h6 {
    font-size: 1rem;
  }
}
.gap-2 {
  gap: 0.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;;gFAAA;EAGA,gDAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,+BAAA;EACA,kBAAA;AACF;;AAEA;EACE,yCAAA,EAAA,kBAAA;EACA,yBAAA,EAAA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,8BAAA;EACA,wCAAA;AACF;;AAEA;EACE,2BAAA;EACA,ifAAA;EAYA,kBAAA;AAVF;AAYA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;EACA,kBAAA;AAVF;AAaA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;EACA,kBAAA;AAXF;AAcA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gEAAA;EACA,kBAAA;AAZF;AAeA;EACE,SAAA;EACA,UAAA;AAbF;;AAgBA;EACE,kEAAA;EACA,kBAAA;AAbF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAZF;;AAeA;;;;;;;;;;;;;;;;;;;;;GAAA;AAuBA;;;;;;;;GAAA;AAUA,oBAAA;AACA;EACE,yBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;;;;;;;;;;;;;;GAAA;AAgBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE,UAAA;EACA,WAAA;AAfF;;AAiBA;EACE,UAAA;EACA,WAAA;AAdF;;AAgBA;EACE,mBAAA;EACA,wBAAA;EACA,kBAAA;AAbF;;AAeA;EACE,mBAAA;AAZF;;AAcA;EACE,mBAAA;AAXF;;AAaA;EACE,mBAAA;EACA,wBAAA;EACA,mBAAA;AAVF;;AAYA;EACE,mBAAA;AATF;;AAWA;EACE,mBAAA;AARF;;AAUA;EACE,uBAAA;AAPF;;AASA;EACE,kEAAA;AANF;;AAQA;EACE,kEAAA;AALF;;AAQA,4BAAA;AACA;EACE,sBAAA;AALF;;AAQA;;;;;;;GAAA;AAQA;EACE,YAAA;EACA,WAAA;EACA,0DAAA;AALF;;AAOA;EACE,WAAA;EACA,YAAA;AAJF;;AAMA;EACE,YAAA;AAHF;;AAKA;EACE,WAAA;EACA,YAAA;AAFF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAGA;EACE,aAAA;AAAF;;AAEA;;;;;;;;GAAA;AAUA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAAF;;AAGA,YAAA;AACA;EACE,0BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,aAAA;EACA,4BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,aAAA;EACA,4BAAA;AAAF;;AAGA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,kCAAA;EACA,6BAAA;AADF;;AAIA;EACE;IACE,UAAA;IACA,UAAA;EADF;EAGA;IACE,UAAA;IACA,UAAA;EADF;EAGA;IACE,UAAA;IACA,WAAA;EADF;AACF;AAIA;EACE,6BAAA;EACA,6BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAEA;;;;;;;;GAAA;AASA;;;;GAAA;AAMA;;GAAA;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAsCA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;AADF;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,mDAAA;EACA,kBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAIF;;AAFA;;;;EAIE,0BAAA;AAKF;;AAHA;;EAEE,oBAAA;AAMF;;AAHA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;;;;;;;;;;;;EAYE,aAAA;EACA,gBAAA;AAQF;;AALA;EACE,iBAAA;AAQF;;AALA;EACE,eAAA;AAQF;;AALA;EACE,kBAAA;AAQF;;AALA;EACE,iBAAA;AAQF;;AALA;EACE,kBAAA;AAQF;;AALA;EACE,eAAA;AAQF;;AALA;EACE,kBAAA;EACA,gBAAA;AAQF;;AANA;EACE,kBAAA;AASF;;AANA;EACE;IACE,uBAAA;IACA,uBAAA;EASF;EAPA;IACE,2BAAA;EASF;EAPA;IACE,yBAAA;IACA,8BAAA;EASF;EANA;IACE,iCAAA;EAQF;EALA;IACE,iCAAA;EAOF;EAJA;IACE,+BAAA;EAMF;EAHA;IACE,iCAAA;EAKF;EAFA;IACE,kBAAA;EAIF;EADA;IACE,eAAA;EAGF;AACF;AADA;EACE,sBAAA;AAGF","sourcesContent":[":root {\n  --bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto,\n    'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif,\n    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg: #fff;\n}\n\nbody {\n  font-family: Arial, Helvetica, sans-serif; /* Fallback font */\n  background-color: #F7FAFF; /* Fallback background color */\n  overflow: hidden;\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@font-face {\n  font-family: 'General-Sans';\n  src: url('./asset/fonts/General-Sans/GeneralSans-Regular.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Extralight.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-ExtralightItalic.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Medium.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Bold.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-BoldItalic.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Italic.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Light.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-LightItalic.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-MediumItalic.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-Semibold.otf'),\n    url('./asset/fonts/General-Sans/GeneralSans-SemiboldItalic.otf');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: url('/src/asset/fonts/Roboto/Roboto-Regular.ttf') format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: url('/src/asset/fonts/Roboto/Roboto-Medium.ttf') format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 600;\n  src: url('/src/asset/fonts/Roboto/Roboto-Bold.ttf') format('truetype');\n  font-display: swap;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\n.filled {\n  font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;\n  font-display: swap;\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  font-size: 1rem;\n  margin: auto;\n}\n\n/* .calenderComponentDark .rdrYearPicker select{\n  color: #BFBFBF;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background: transparent;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n    background-repeat: no-repeat;\n    background-position-x: 100%;\n    background-position-y: 52%;\n    border-radius: 2px;\n}\n.calenderComponentDark .rdrMonthPicker select{\n  color: #BFBFBF;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background: transparent;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n    background-repeat: no-repeat;\n    background-position-x: 100%;\n    background-position-y: 52%;\n    border-radius: 2px;\n} */\n\n/* .calenderComponentDark .rdrYearPicker option{\n  background-color: #5A5A5A;\n  color: #DCDCDC;\n}\n\n.calenderComponentDark .rdrMonthPicker option{\n  background-color: #5A5A5A;\n  color: #DCDCDC;\n} */\n\n/* For Light Theme */\n.calenderComponent .rdrYearPicker option {\n  background-color: #5a5a5a;\n  color: #dcdcdc;\n}\n\n.calenderComponent .rdrMonthPicker option {\n  background-color: #5a5a5a;\n  color: #dcdcdc;\n}\n\n.rdrDayToday .rdrDayNumber span:after {\n  display: none;\n}\n\n.calenderComponentDark .rdrDefinedRangesWrapper {\n  display: none;\n}\n\n/* .calenderComponentDark .rdrDateRangeWrapper{\n  background: #3B3B3C;\n}\n\n.calenderComponentDark .rdrDayNumber span {\n  color: #BFBFBF;\n  font-weight: 500;\nfont-size: 15px;\n}\n\n.calenderComponentDark .rdrMonthAndYearPickers{\n  font-weight: 500;\nfont-size: 18px;\ncolor: #BFBFBF;\n} */\n\n.calenderComponent .rdrDayNumber span {\n  color: #444f5f;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.calenderComponent .rdrMonthAndYearPickers select {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  color: #444f5f;\n}\n\n.calenderComponent .rdrMonthAndYearWrapper .rdrNextPrevButton {\n  background: #d9d9d9;\n}\n\n.calenderComponent .rdrDefinedRangesWrapper {\n  display: none;\n}\n\n::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n}\n::-webkit-scrollbar-button {\n  width: 0px;\n  height: 0px;\n}\n::-webkit-scrollbar-thumb {\n  background: #349ef5;\n  border: 0px none #ffffff;\n  border-radius: 3px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #005aa3;\n}\n::-webkit-scrollbar-thumb:active {\n  background: #004f8f;\n}\n::-webkit-scrollbar-track {\n  background: #c7c7c7;\n  border: 0px none #ffffff;\n  border-radius: 50px;\n}\n::-webkit-scrollbar-track:hover {\n  background: #bfbfbf;\n}\n::-webkit-scrollbar-track:active {\n  background: #bfbfbf;\n}\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n.solid-icon {\n  font-variation-settings: 'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 48;\n}\n.outlined-icon {\n  font-variation-settings: 'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 48;\n}\n\n/* theme toggle button css */\n.react-switch {\n  border: 1px solid #ccc;\n}\n\n/* .carousel.carousel-slider .control-arrow {\n  color: #fff;\n  font-size: 26px;\n  margin-top: 50%;\n  border-radius: 50%;\n  height: 50px;\n  width: 50px;\n} */\n.carousel-div {\n  height: 100%;\n  width: 100%;\n  /* background-image: url('./asset/images/Carousel.svg'); */\n}\n.carousel-slider {\n  width: 100%;\n  height: 100%;\n}\n.carousel .slider-wrapper {\n  height: 100%;\n}\n.carousel .slider-wrapper.axis-horizontal .slider {\n  width: 100%;\n  height: 100%;\n}\n.carousel .slide {\n  width: 100%;\n  height: 100%;\n}\n.carousel-status {\n  display: none;\n}\n/* .carousel .slide img {\n  width:auto;\n  height:100%\n\n}\n.carousel .img{\n  width:auto;\n  height:100%\n} */\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.card-text {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.card-text-attendence {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1; /* number of lines to show */\n  line-clamp: 1;\n  -webkit-box-orient: vertical;\n}\n\n@keyframes glow {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.header-glow {\n  animation: glow 2s infinite linear;\n  animation-fill-mode: forwards;\n}\n\n@keyframes splash {\n  0% {\n    opacity: 1;\n    z-index: 4;\n  }\n  90% {\n    opacity: 1;\n    z-index: 4;\n  }\n  100% {\n    opacity: 0;\n    z-index: -1;\n  }\n}\n\n.splash-screen {\n  animation: splash 6.1s linear;\n  animation-fill-mode: forwards;\n}\n\n.blur-Modal {\n  position: absolute;\n  z-index: 100;\n  top: 0px;\n  background: rgba(255, 255, 255, 0.9);\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n.blur-Modal .blur-Modal-content {\n  overflow: hidden;\n}\n.blur-Modal .blur-Modal-content .inner-body-modal {\n  background: rgba(128, 128, 128, 0.3);\n  padding: 25px;\n  border-radius: 8px;\n  position: relative;\n  z-index: 4;\n  margin-top: 60px;\n}\n\n[role='grid'] {\n  width: 94vw !important;\n}\n/* .react-draggable {\n  user-drag: none;\n  -webkit-user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  transform: none;\n} */\n/* @media screen and (max-width: 768px) {\n  .react-draggable {\n    transform: none !important;\n  }\n} */\n\n/* [aria-label='Screen share control bar'] .zmwebsdk-MuiBox-root {\n  flex-wrap: wrap !important;\n} */\n\n/* .zmwebsdk-MuiPaper-root {\n  width: 100vw !important;\n  min-width: 100vw !important;\n  max-width: 100vw !important;\n}\n.react-draggable .zmwebsdk-MuiPaper-root .zmwebsdk-MuiBox-root {\n  height: 100vh;\n  width: 100vw;\n}\n#meetingSDKElement .zmwebsdk-makeStyles-videoCustomize-1 {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n#suspension-view-tabpanel-active > div:first-child {\n  height: 88vh;\n}\n[class^='zmwebsdk-makeStyles-draggableDivider'] {\n  display: none !important;\n}\n[class*='zmwebsdk-makeStyles-inSharing'] {\n  height: 90vh !important;\n}\n[class*='zmwebsdk-makeStyles-inSharing'] .zmwebsdk-MuiBox-root {\n  height: 24px !important;\n  width: 100% !important;\n  position: fixed;\n  top: 36px !important;\n  transform: none;\n  max-width: none !important;\n}\n\n#suspension-view-tabpanel-active {\n  height: 83vh;\n}\n.zmwebsdk-makeStyles-videoCustomize-1 .zmwebsdk-MuiPaper-root {\n  box-shadow: none;\n} */\n#meetingSDKElement {\n  height: 100vh;\n  width: 100vw;\n  background-color: #242424;\n  display: none;\n}\n#menu-list-undefined li:first-child {\n  display: none;\n}\n#participants-ul {\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.material-symbols-outlined {\n  font-family: 'Material Symbols Outlined' !important;\n  font-display: swap;\n}\n.material-symbols-rounded {\n  font-display: swap;\n}\nbutton:not(:disabled) {\n  cursor: pointer;\n}\nbutton {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n[type='button'],\n[type='reset'],\n[type='submit'],\nbutton {\n  -webkit-appearance: button;\n}\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\nbutton {\n  border-radius: 0;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n.position-relative {\n  position: relative;\n}\n\n@media screen and (max-width: 768px) {\n  .common-window {\n    width: 100vw !important;\n    height: 90vh !important;\n  }\n  .sharee-sharing-indicator {\n    max-width: 100vw !important;\n  }\n  .sharee-sharing-indicator__tip {\n    padding: 0 7px !important;\n    max-width: calc(100vw - 125px);\n  }\n\n  h1 {\n    font-size: calc(1.375rem + 1.5vw);\n  }\n\n  h2 {\n    font-size: calc(1.325rem + 0.9vw);\n  }\n\n  h3 {\n    font-size: calc(1.3rem + 0.6vw);\n  }\n\n  h4 {\n    font-size: calc(1.275rem + 0.3vw);\n  }\n\n  h5 {\n    font-size: 1.25rem;\n  }\n\n  h6 {\n    font-size: 1rem;\n  }\n}\n.gap-2 {\n  gap: 0.5rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
